import { FilterResult } from "./types";

export class DateRangeFilterUtil {
  // modify dateRangeTo (j+1) to include date in search
  public static modifyDateRangeTo(filters: FilterResult[]): FilterResult[] {
    for (const dateFilter of filters.filter(f => f.operator === "BETWEEN" && f.value.to)) {
      const date = new Date(dateFilter.value.to);
      const dayAfterDate = date.setDate(date.getDate() + 1);
      const from = dateFilter.value.from;
      const index = filters.indexOf(dateFilter);
      const newDateFilter = {
        key: dateFilter.key,
        operator: "BETWEEN",
        value: {
          ...(from ? { from: from } : undefined),
          to: new Date(dayAfterDate).toISOString().slice(0, -14),
        },
      };
      filters.splice(index, 1, newDateFilter);
    }
    return filters;
  }
}
